import React from "react";
import { IoIosArrowRoundForward } from "react-icons/io";
import { GlobalStore } from "../../stores/global";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function Sponsors({ content }) {
  const config = GlobalStore.useState(c => c.config);
  const { appStoreLink } = config.storeLinks;

  return (
    <div className="banner" id="sponsors">
      <div className="sponsors">
        {((content && content.list) || []).map(({ linkUrl, media = {} }, i) => {
          const imageUrl = media.formats?.thumbnail?.url || media.url;
          return (
            <a key={i} target="tab" href={linkUrl}>
              <LazyLoadImage alt={media.alternativeText} src={imageUrl} effect="blur" />
            </a>
          );
        })}
      </div>
      <a href={appStoreLink}>
        <div className="bookingSection">
          <p>Sign up now</p>
          <p>
            <IoIosArrowRoundForward />
          </p>
        </div>
      </a>
    </div>
  );
}
